import { render, staticRenderFns } from "./Benzinga.vue?vue&type=template&id=15826d18&"
import script from "./Benzinga.vue?vue&type=script&lang=js&"
export * from "./Benzinga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports